<template>
  <div class="block-insert-block">
    <h3 class="block-insert-block__title">{{ $t('view.flow.block.blockInsert.title') }}</h3>
    <sel
      :label="$t('view.flow.block.blockInsert.block')"
      v-model="val.block"
      class="block-insert-block__select"
      @input="onInput()"
    >
      <optgroup v-for="group in this.$store.state.flowGroups" :key="group.id" :label="group.name">
        <option v-for="block in group.blocks" :key="block.id" :value="block.uuid">{{ block.name }}</option>
      </optgroup>
    </sel>
    <div
      v-if="blockVariables && Object.keys(blockVariables).length"
      class="block-insert-block__warning"
    >
      {{$t('view.flow.block.blockInsert.variablesWarning')}}
      <b>{{ Object.keys(blockVariables).toString().replace(/,/, ', ') }}</b>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created() {
    this.val = this.value
  },
  methods: {
    onInput() {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  },
  computed: {
    blockVariables: function () {
      const block = this.$store.getters.flowBlock(this.val.block)
      if (!block) return null
      return block.data.variables
    }
  }
}
</script>

<style lang="scss" scoped>
.block-insert-block {
  @include flowElementShadow();
  width: 35%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__separator {
    margin-top: 20px;
  }

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }

  &__warning {
    margin-top: 10px;
    font-style: italic;
    font-size: 0.9em;
  }
}
</style>
